// Central test IDs + brand constants
export const LOGO_URL =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_msme-subsidy-hub/artifacts/yetaucfs_Logo%20mm%20010010.png";

export const CONTACT_PHONES = ["+91 70921 91919", "+91 90000 06953"];
export const CONTACT_EMAILS = ["paras@msmemoney.com", "manjul@msmemoney.com"];
export const CONTACT_PHONE = CONTACT_PHONES[0];
export const CONTACT_EMAIL = CONTACT_EMAILS[0];
export const WHATSAPP_NUMBER = "917092191919";

export const TID = {
  nav: {
    root: "nav-root",
    logo: "nav-logo",
    cta: "nav-cta",
    link: (name) => `nav-link-${name}`,
    mobileToggle: "nav-mobile-toggle",
    mobileMenu: "nav-mobile-menu",
  },
  hero: {
    root: "hero-root",
    title: "hero-title",
    subtitle: "hero-subtitle",
    ctaPrimary: "hero-cta-primary",
    ctaSecondary: "hero-cta-secondary",
    dpiit: "hero-dpiit",
  },
  stats: { root: "stats-root" },
  services: {
    root: "services-root",
    card: (n) => `service-card-${n}`,
  },
  cases: { root: "cases-root", cta: "cases-cta" },
  why: { root: "why-root" },
  testimonials: { root: "testimonials-root" },
  about: { root: "about-root" },
  contact: {
    root: "contact-root",
    name: "contact-name",
    company: "contact-company",
    phone: "contact-phone",
    email: "contact-email",
    state: "contact-state",
    service: "contact-service",
    serviceOption: (v) => `contact-service-option-${v}`,
    message: "contact-message",
    submit: "contact-submit",
    success: "contact-success",
    error: "contact-error",
  },
  footer: { root: "footer-root" },
  wa: "whatsapp-fab",
  marquee: "marquee",
};
